import { render, staticRenderFns } from "./AddReservationModal.vue?vue&type=template&id=1057c0b6&"
import script from "./AddReservationModal.vue?vue&type=script&lang=js&"
export * from "./AddReservationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports